import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchSuiteUsersDone = (_, { payload }) => {
  return [
    ...payload,
  ]
};

const saveSuiteContactDone = (suiteUsers,  { payload } ) => {
  return [ ...suiteUsers,payload];
};

const updateSuiteContactDone = (suiteUsers,  { payload } ) => {
  return suiteUsers.map( c => {
    if( c.id === payload.id){
      return payload
    }
    return c
 })
};

const clearSuiteUsers = () => {
  return initialState
}
const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_SUITE_USERS_LIST]: fetchSuiteUsersDone,
  [TYPES.SAVE_SUITE_CONTACT_DONE]: saveSuiteContactDone,
  [TYPES.UPDATE_SUITE_CONTACT_DONE]: updateSuiteContactDone,
  [TYPES.CLEAR_SUITE_USERS]: clearSuiteUsers
});
